<template>
  <div class="add-skill-main">
    <div
      v-show="addSkillStep === 0"
      class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base"
    >
      <div class="vx-card p-2">
        <!---->
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <div class="vx-card__body">
            <div class="text-center">
              <h4>Welcome to Coach</h4>
            </div>
            <div
              class="con-vs-avatar mx-auto my-6 block 80px"
              style="width: 200px; height: 150px; background: white/*rgb(195, 195, 195)*/;"
            >
              <!---->
              <div class="">
                <img
                  src="@/assets/Illustrations/Ill_No Data.svg"
                  alt=""
                  style="color: grey;"
                />
              </div>
            </div>
            <div class="text-center">
              <p class="text-grey">You haven't added any skills</p>
              <p class="text-grey">
                When you add skills, they will appear below
              </p>
              <br />
            </div>
            <vs-button
              class="w-full"
              color="primary"
              type="filled"
              @click="addSkillStep = addSkillStep + 1"
              >Add New Skill</vs-button
            >
          </div>
        </div>
      </div>
    </div>

    <SelectCharacteristics
      v-if="addSkillStep === 1"
      v-on:childToParent="onChildClick"
    />

    <SelectCompetency v-else-if="addSkillStep === 2" />

    <RateYourLevel v-show="addSkillStep === 3" />

    <TrainingDuration v-show="addSkillStep === 4" />

    <ProgressMeasure v-show="addSkillStep === 5" />

    <ReviewSkill v-show="addSkillStep === 6" />

    <div v-show="addSkillStep === 6" class="mb-base" @click="addSkillStep = 1">
      <h6 class="text-center">
        <a href="#"><u>Edit my skill</u></a>
      </h6>
    </div>

    <div class="relative">
      <div v-show="addSkillStep > 1" class="vx-col w-full footer-next">
        <div class="vx-card vx-card-next">
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
              <div class="vx-row">
                <div class="vx-col w-full mb-2">
                  <vs-button
                    v-if="addSkillStep < 6"
                    class="w-full add-skill-step-back-next"
                    color="primary"
                    type="filled"
                    :disabled="disabledNextButton"
                    @click="addSkillStep = addSkillStep + 1"
                    >Next</vs-button
                  >

                  <vs-button
                    v-else-if="addSkillStep === 6"
                    class="w-full add-skill-step-back-next"
                    color="primary"
                    type="filled"
                    @click="saveUserSkill"
                    >Push to my coach</vs-button
                  >
                </div>
                <div class="vx-col mt-1 w-full">
                  <div @click="addSkillStep = addSkillStep - 1">
                    <h6 class="text-center">
                      <a href="#"><u>Back</u></a>
                    </h6>
                  </div>
                  <!--<vs-button
                    class="w-full add-skill-step-back"
                    color="primary"
                    type="border"
                    @click="addSkillStep = addSkillStep - 1"
                  >Back</vs-button
                  >-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencilRuler } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import SelectCharacteristics from "./SelectCharacteristics";
import SelectCompetency from "./SelectCompetency";
import RateYourLevel from "./RateYourLevel";
import TrainingDuration from "./TrainingDuration";
import ProgressMeasure from "./ProgressMeasure";
import ReviewSkill from "./ReviewSkill";

library.add(faPencilRuler);

export default {
  name: "AddSkillStep3",
  data() {
    return {
      addSkillStep: this.$store.state.addSkill.addSkillStep
    };
  },
  watch: {},
  components: {
    ReviewSkill,
    ProgressMeasure,
    TrainingDuration,
    RateYourLevel,
    SelectCompetency,
    SelectCharacteristics,
    FontAwesomeIcon
  },
  computed: {
    disabledNextButton() {
      // Characteristics
      if (
        this.addSkillStep === 1 &&
        (this.$store.state.addSkill.characteristic.length > 3 ||
          this.$store.state.addSkill.characteristic.length < 1)
      )
        return true;
      else if (
        this.addSkillStep === 2 &&
        this.$store.state.addSkill.competency.length === 0
      )
        return true;
      else return false;
    }
  },
  mounted() {
    this.addSkillStep = this.$store.state.addSkill.addSkillStep;

    const characteristicId = parseInt((this.$route.params.characteristicId).replace("char-",""));
    const competencyId = parseInt((this.$route.params.competencyId).replace("comp-",""));

    this.$store
      .dispatch("addSkill/getCompetency", competencyId)
      .then(resGet => {
        console.log("competency already add", resGet);
      })
      .catch(err => {
        console.log("competency not yet added", err);
        this.$store
          .dispatch("addSkill/getCompetencyFromList", competencyId)
          .then(resGetFromList => {
            console.log("step 3 competency", resGetFromList);
            if (parseInt(resGetFromList.characteristicId) === parseInt(characteristicId)) {
              console.log("competency match found");
              const compObj = {
                id: resGetFromList.id,
                title: resGetFromList.competency,
                value: resGetFromList.wellDevelopedDefinition,
                icon: require(`@/assets/Iconography/Attributes/${resGetFromList.icon}`)
              }
              this.$store
                .dispatch("addSkill/setSelectedCompetency", compObj)
                .then(resComp => {
                  console.log(resComp);
                  this.$store
                    .dispatch(
                      "addSkill/addSelectedCharacteristic",
                      characteristicId
                    )
                    .then(resChar => {
                      console.log("resChar", resChar);
                      this.addSkillStep = this.addSkillStep + 3;
                    })
                    .catch(errorChar => {
                      console.log(errorChar);
                    });
                })
                .catch(errorComp => {
                  console.log("errorComp", errorComp);
                });
            }
            else{
              console.log("competency mismatch error")
            }
          })
          .catch(err => {
            console.log("err step 3 competency does not exist", err);
          });
      });

    /*console.log(this.addSkillStep, characteristicId);
    this.$store
      .dispatch("addSkill/addSelectedCharacteristic", characteristicId)
      .then(res => {
        console.log("selected characteristics skipped", res.data);
        console.log(
          "store sc skipped",
          this.$store.state.addSkill.characteristic
        );
        this.addSkillStep = this.addSkillStep + 2;
      })
      .catch(err => {
        console.log("could not add selected characteristics", err);
      });*/
  },
  methods: {
    onChildClick(value) {
      console.log("from child", value);
      this.addSkillStep = this.addSkillStep + 1;
    },
    saveUserSkill() {
      const userNewSkill = {
        usersId: this.$store.state.AppActiveUser.usersId,
        // characteristic: this.$store.state.addSkill.characteristics,
        competencyId: this.$store.state.addSkill.competency.id,
        initialLevel: this.$store.state.addSkill.initialLevel,
        trainingDuration: this.$store.state.addSkill.trainingDuration,
        progressMeasureId: this.$store.state.addSkill.progressMeasure.id,
        progressStatus: "in_progress"
      };
      console.log("going to save user skill", userNewSkill);
      this.$store
        .dispatch("addSkill/saveUserSkill", userNewSkill)
        .then(res => {
          console.log("New Skill Created", res);
          this.$router.push({
            name: "skill-details",
            params: { competencyId: res.id }
          });
        })
        .catch(err => console.log("Skill could not be created", err));
    }
  }
};
</script>

<style scoped>
.footer-next {
  position: fixed;
  bottom: 0;
  /*width: 100%;*/
  width: 100vw;
  left: calc(-50vw + 50%);
}

.vx-card-next {

}

.add-skill-main {
  margin-bottom: 5rem;
}
</style>
